import { Package, StackSimple, X } from '@phosphor-icons/react';
import { AppTable, LoaderBar } from '@components/index';
import { BoldText, ShadowBox } from '@elements/index';
import { useMemo } from 'react';
import styled from 'styled-components';
import { CommonUtility } from '@utility/index';
import { LocationItemRow } from './LocationItemRow';

const ItemsContainer = styled(ShadowBox)`
  background-color: ${({ theme }) => theme.colors.box} !important;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  td,
  th {
    background-color: ${({ theme }) => theme.colors.box} !important;
  }

  transition: all 0.5s;

  width: 560px;

  &.open {
    transform: translateX(0px);
    opacity: 1;
  }

  &.close {
    transform: translateX(-100px);
    opacity: 0;
  }

  &.loading {
    min-height: 200px;
  }
`;

const TableContainer = styled.div`
  max-height: 38vh;
  overflow-y: auto;
`;

export function StoredAtLocationItems({
  openSecondary,
  locationData,
  setOpenSecondary,
  columns,
  data,
  summaryLoading,
}) {
  const parsedData = useMemo(() => {
    const groups = [];
    data.forEach(lot => {
      if (CommonUtility.isValidObject(lot.pallet)) {
        const palletIndexInGroup = groups.findIndex(
          x => x[0].pallet?.palletNumber === lot.pallet.palletNumber,
        );
        if (palletIndexInGroup > -1) {
          groups[palletIndexInGroup].push(lot);
        } else {
          groups.push([lot]);
        }
      } else if (groups[0]) {
        groups[0].push(lot);
      } else {
        groups[0] = [lot];
      }
    });
    return groups;
  }, [data]);

  return (
    <ItemsContainer
      className={`ml-4 ${openSecondary ? 'open' : 'close'} ${
        summaryLoading ? 'loading' : ''
      }`}
    >
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <Package size={17} />
          <span className="mx-1">Stored At</span>
          <BoldText>{locationData?.code}</BoldText>
        </div>
        <X size={17} className="cursor-pointer" onClick={() => setOpenSecondary(false)} />
      </div>
      {summaryLoading ? (
        <LoaderBar />
      ) : (
        <TableContainer>
          {!CommonUtility.isValidArray(parsedData) && <span>No items found</span>}
          {parsedData?.map(group => (
            <div key={group[0].lotNumber}>
              {group[0].pallet?.palletNumber && (
                <div className="d-flex align-items-center">
                  <StackSimple size={20} />
                  <BoldText className="ml-1">{group[0].pallet?.palletNumber}</BoldText>
                </div>
              )}
              <AppTable
                columns={columns}
                data={group}
                noShadow
                RowComponent={<LocationItemRow />}
                wrapperClass="mt-0"
                loadingRows={2}
              />
            </div>
          ))}
        </TableContainer>
      )}
    </ItemsContainer>
  );
}
